/**
 * @file: storeFeatureOfClientPlatform.ts
 * @copyright: (c) 2019-2020 sichuan zhichetech co., ltd.
 */

import { StoreFeature } from '@euler/model/enum';
import { clientPlatform } from '@euler/services/clientPlatform';

/**
 * The feature this build needs before anything else works: the web version
 * and the hub build are sold on their own, and the server refuses every
 * request of a store without them.
 */
export function storeFeatureOfClientPlatform(): StoreFeature | null {
  switch (clientPlatform()) {
    case 'web':
      return StoreFeature.WorkbenchWeb;
    case 'tv':
      return StoreFeature.HubDisplay;
    default:
      return null;
  }
}
